module.exports = __webpack_public_path__ + "img/openruyi.793d94b8.svg";